import { AlertResponse } from "../types/media";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { EDS_DATES_ID } from "../hooks/useEdsDatesFilter";

export const checkEdsFilter = (
  alert: AlertResponse | undefined,
  filterValues: FilterValue[]
): boolean => {
  const edsDateValue = filterValues.find(
    (f) => f.filterId === EDS_DATES_ID
  )?.value;

  if (edsDateValue) {
    return (
      (alert?.eds ?? 0) > 0 &&
      (alert?.edsDates?.includes(edsDateValue as string) ?? false)
    );
  }
  return (alert?.eds ?? 0) > 0;
};
